import React, { useContext, useEffect } from "react";
import styles from "./Stars.module.scss";
import PathContext from "../../context/path";
import { useRef } from 'react';
const Stars = (props) => {
  const { number, value, color } = props;
  const path = useContext(PathContext);
  const refWrap = useRef(null);
  let wrapClass = `${styles.wrap}`;
  let stars = [];
  useEffect(()=>{
    const wrap = refWrap.current;
      let options = {
        threshold: 1,
        rootMargin: '0% 0% 0% 0%'
      }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add(styles.animate);
          observer.unobserve(entry.target);
        }
      })
    }, options);
    observer.observe(wrap);
    return()=>{
      observer.unobserve(wrap);
    }
  },[]);
  if (color !== undefined && styles[`wrap_${color}`] !== undefined) {
    wrapClass += ` ${styles[`wrap_${color}`]}`;
  }
  if (number !== undefined && number > 0) {
    for (let index = 0; index < number; index++) {
      let innerStar = null;
      if (value !== undefined && index < value) {
        innerStar = <div className={styles.star__inner}>
          <svg width="26" height="25" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.8478 0.969678L16.8631 7.64165L16.9723 7.82314L17.1787 7.87094L24.7649 9.62792L19.6602 15.5084L19.5214 15.6684L19.5397 15.8794L20.213 23.6372L13.0429 20.5996L12.8478 20.517L12.6528 20.5996L5.4827 23.6372L6.15598 15.8794L6.17429 15.6684L6.03544 15.5084L0.930795 9.62792L8.517 7.87094L8.72336 7.82314L8.83259 7.64165L12.8478 0.969678Z" fill="#33AC66" stroke="#33AC66" />
          </svg>

        </div>;
      }
      let star = <div className={styles.star} key={`star-${index}`}>
        <div className={styles.star__body}>
          <svg width="26" height="25" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.8478 0.969678L16.8631 7.64165L16.9723 7.82314L17.1787 7.87094L24.7649 9.62792L19.6602 15.5084L19.5214 15.6684L19.5397 15.8794L20.213 23.6372L13.0429 20.5996L12.8478 20.517L12.6528 20.5996L5.4827 23.6372L6.15598 15.8794L6.17429 15.6684L6.03544 15.5084L0.930795 9.62792L8.517 7.87094L8.72336 7.82314L8.83259 7.64165L12.8478 0.969678Z" fill="#33AC66" stroke="#33AC66" />
          </svg>
        </div>
        {innerStar}
      </div>;
      stars.push(star);
    }
  }

  return (
    <>
      <div className={wrapClass} ref={refWrap}>
        <div className={styles.title}>Уровень ответственности</div>
        <div className={styles.list}>
          {stars}
        </div>
      </div>
    </>
  );

}

export default Stars;
